module.exports = __webpack_public_path__ + "32bd04c865486a5b5bb928afd472d0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/print-invoice.png
// module id = 572
// module chunks = 0